import { lazyRoute } from './lazyRoute';

export const publicRoutes = {
  children: [
    {
      lazy: () => lazyRoute('/PlayerPage/PlayerPage'),
      path: 'workouts/:workoutId',
    },
    {
      children: [
        {
          children: [
            {
              children: [
                {
                  index: true,
                  lazy: () => lazyRoute('/PlayerPage/PlayerPage'),
                  path: ':programId',
                },
              ],
              path: 'programs',
            },
            {
              children: [
                {
                  index: true,
                  lazy: () => lazyRoute('/PlayerPage/PlayerPage'),
                  path: ':workoutId',
                },
              ],
              path: 'workouts',
            },
            {
              index: true,
              lazy: () =>
                lazyRoute('/Profiles/OrganizationProfile/OrganizationProfile'),
            },
          ],
          path: ':organizationId',
        },
        {
          handle: { title: 'organizations' },
          index: true,
          lazy: () => lazyRoute('/Organizations/PublicOrganizations'),
        },
      ],
      path: 'organizations',
    },
    {
      handle: { title: 'organizations' },
      index: true,
      lazy: () => lazyRoute('/Authors/PublicAuthors'),
      path: 'authors',
    },
  ],
  handle: { title: 'public' },
  path: 'public',
};
